import { render } from "./sidebarmenu.vue?vue&type=template&id=0b91300e&scoped=true"
import script from "./sidebarmenu.vue?vue&type=script&lang=js"
export * from "./sidebarmenu.vue?vue&type=script&lang=js"

import "./sidebarmenu.vue?vue&type=style&index=0&id=0b91300e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b91300e"]])

export default __exports__